import Vue from 'vue';
import i18n from "../translation";

/**
 * Manages the current user's own Personal Access Tokens (PATs).
 * Always scoped to the logged in user — there is no admin/on-behalf-of view.
 */
const state = {
    tokens: {},
    // the raw secret of a just-created token, shown once, then cleared
    // (e.g. when the create dialog is closed) — never persisted
    lastCreatedToken: null,
};

const getters = {
    getAccessTokens: (state) => {
        return Object.values(state.tokens).sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt);
        });
    },
    getAccessTokenById: (state) => (id) => {
        return state.tokens[id];
    },
    getLastCreatedAccessToken: (state) => {
        return state.lastCreatedToken;
    },
};

const mutations = {
    loadAccessTokensMutation(state, data) {
        Vue.set(state, 'tokens', {});
        for (let i = 0; i < data.length; i++) {
            Vue.set(state.tokens, data[i].id, data[i]);
        }
    },
    addAccessTokenMutation(state, data) {
        Vue.set(state.tokens, data.id, data);
    },
    removeAccessTokenMutation(state, id) {
        if (state.tokens[id]) {
            Vue.delete(state.tokens, id);
        }
    },
    setLastCreatedAccessTokenMutation(state, token) {
        state.lastCreatedToken = token;
    },
};

const actions = {
    loadAccessTokens: async ({commit, dispatch}) => {
        return dispatch('clientGetPersonalAccessTokens').then(data => {
            commit('loadAccessTokensMutation', data);
            return data;
        });
    },
    createAccessToken: async ({commit, dispatch}, args) => {
        return dispatch('clientCreatePersonalAccessToken', args).then(data => {
            // strip the raw secret before storing it in the regular token
            // list — only setLastCreatedAccessTokenMutation should hold it,
            // and only transiently
            // eslint-disable-next-line no-unused-vars
            const { token, ...withoutToken } = data;
            commit('addAccessTokenMutation', withoutToken);
            commit('setLastCreatedAccessTokenMutation', data);
            dispatch('createNotification', {'text': i18n.t('events.accessTokenCreated')});
            return data;
        });
    },
    revokeAccessToken: async ({commit, dispatch}, args) => {
        return dispatch('clientRevokePersonalAccessToken', args).then(() => {
            commit('removeAccessTokenMutation', args.tokenId);
            dispatch('createNotification', {'text': i18n.t('events.accessTokenRevoked')});
        });
    },
    clearLastCreatedAccessToken: ({commit}) => {
        commit('setLastCreatedAccessTokenMutation', null);
    },
};

export default {
    state, getters, mutations, actions
}
